<div class="privacy-page">
  <div class="text-center">
    <h1>Privacy Policy</h1>
  </div>

  <div _ngcontent-aun-c114 class="settings-tab-data">
    <!-- Hidden Content Section -->
    <div _ngcontent-aun-c114 style="display: none">
      <div _ngcontent-aun-c114 class="text-center my-3">
        <!-- <img _ngcontent-aun-c114 src="assets/img/legal-terms.png" class="img-responsive" /> -->
      </div>

      <div _ngcontent-aun-c114>
        <p>
          Wooffer's Working Together Priorities aim to enhance the quality and
          security of independent work in the United States. With industry
          change, along with government action, we believe our Priorities will
          improve work for the millions of independent workers, while preserving
          the flexibility that we know you value.
        </p>

        <h5>Trip Important Questions</h5>

        <p>
          <strong>My toll or parking fee wasn't included in my fare</strong>
        </p>
        <p>
          When your vehicle passes through a toll on a trip, Wooffer uses
          geographic technology to add the toll amount to your rider's fare
          automatically. The Wooffer fee is not applied to any toll-related
          charges added to the fare, and these rebates can be found on your
          earnings statement. If a toll-related rebate is not appearing on your
          earnings statement, please provide details and we will review. Please
          note that in US and Canadian cities, you won't receive a rebate for
          general parking fees incurred while on a trip.
        </p>

        <p><strong>I was in an accident.</strong></p>
        <p>
          If you are involved in an accident, contact the police and paramedics
          if necessary. You can let us know what happened by checking that you
          have selected the correct trip and sharing all available info here. A
          member of our team will reach out. Please provide clear, bright photos
          of all four sides of your vehicle. Even if the accident did not result
          in visible damage or only damaged a specific area, we request photos
          of your entire vehicle.
        </p>
        <p>
          Accidents expenses are not covered by Wooffer Technologies, Inc. You
          need to contact your insurance for accidental coverage.
        </p>

        <p><strong>My rider was rude</strong></p>
        <p>
          Our rating system is in place to help keep Wooffer comfortable and
          safe for everyone. When rating your trips, please enter a rating that
          reflects your trip experience with the rider. Please note, we do not
          change rider ratings once they have been entered into the app.
        </p>

        <p><strong>The rider or pet made a mess in my vehicle</strong></p>
        <p>
          Please email your complaint and all the supporting documents and
          photos to info@wooffertechnologies.com. If a rider made a mess that
          requires significant cleaning, we may be able to charge the rider and
          issue you a cleaning fee. This process may take up to 60 days.
        </p>

        <p>
          To request a cleaning fee, please submit a photo of the mess along
          with the receipt for the cleaning service within 3 business days.
          Receipt must include:
        </p>

        <ul>
          <li>Date of service (within 3 days of the trip)</li>
          <li>Name of the cleaning service</li>
        </ul>

        <p>Examples of cleaning fee tiers:</p>
        <ul>
          <li>$20–$30: Small interior mess (minor spills, dirt, etc.)</li>
          <li>$40–$50: Moderate interior mess (larger spills, etc.)</li>
          <li>$100: Major bodily fluid mess</li>
        </ul>

        <p><strong>I found an item</strong></p>
        <p>
          Let us know if you notice an item left behind. Riders can call you
          through the app anonymously. If you prefer a text, we can send them
          your number — note, they may retain this.
        </p>

        <h5>Critical Safety Response Line</h5>
        <p>
          If you require immediate help, call 911. Once all parties are safe,
          click below to speak with a Wooffer representative.
        </p>

        <p>
          Drivers agree to hold Wooffer Technologies harmless from any future
          issues caused by the rider or pet. Wooffer Technologies will not be
          liable for incidents during or after service usage.
        </p>

        <h5>Trips Recommendations</h5>
        <ul>
          <li>Go offline when unavailable to take trips.</li>
          <li>Breaching cancellation policies may lead to restrictions.</li>
          <li>
            Unacceptable cancellation reasons include:
            <ul>
              <li>Destination-based refusal</li>
              <li>Dynamic pricing refusal</li>
              <li>Discriminatory behavior (per law and license conditions)</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- Privacy Policy Block -->
    <div _ngcontent-aun-c114 class="d-block">
      <div class="text-center my-3">
        <img
          src="https://wooffertechnologies.com/assets/img/legal-privacy.png"
          class="img-fluid"
        />
      </div>

      <p><strong>Privacy Notice Policy and Information:</strong></p>
      <p>
        Wooffer's Privacy Notice explains the information we collect, how it is
        used and shared, and your choices. This applies to all users globally
        unless stated otherwise.
      </p>

      <p>
        <strong><em>Wooffer Technologies Privacy Notice</em></strong>
      </p>
      <p>
        <strong>Introduction:</strong> When you use Wooffer Technologies, you
        trust us with your data. We’re committed to keeping that trust.
      </p>
      <p>
        <strong>Last modified:</strong> March 19, 2026<br /><strong
          >Effective date:</strong
        >
        April 1, 2021
      </p>
      <p>
        Read full policy:
        <a
          href="https://drive.google.com/file/d/1uXMZLA5LU61bn6DS9XpDKyx5sIxplmSk/view?usp=sharing"
          target="_blank"
          >here</a
        >
      </p>

      <p><strong>Scope:</strong></p>
      <p>This notice applies to:</p>
      <ul>
        <li>Riders</li>
        <li>Drivers</li>
        <li>Delivery recipients</li>
        <li>Delivery persons</li>
      </ul>

      <p>We may also collect data from people who:</p>
      <ul>
        <li>Use Wooffer for Business</li>
        <li>Are restaurant partners</li>
        <li>Begin but do not complete driver/delivery applications</li>
      </ul>

      <p><strong>Data Collection and Use:</strong></p>
      <ul>
        <li>Data you provide (e.g. during account creation)</li>
        <li>Data generated during usage (e.g. location, app usage)</li>
        <li>Data from partners and third parties (e.g. via APIs)</li>
      </ul>

      <p><strong>Choice and Transparency:</strong></p>
      <ul>
        <li>In-app settings and device permissions</li>
        <li>Marketing opt-outs</li>
        <li>Data access and deletion requests</li>
      </ul>

      <p><strong>Updates:</strong></p>
      <p>
        We may update this notice. Continued use after notification means you
        accept the changes, unless restricted by law.
      </p>

      <h5>Pet Policy</h5>
      <ul>
        <li>Pets will not be fed or walked during the ride.</li>
        <li>Pet must be vaccinated per local laws.</li>
        <li>Pet must not be aggressive.</li>
        <li>Pet must wear a collar and leash.</li>
        <li>Toys must be removed after the ride.</li>
      </ul>

      <p>
        <strong>Dangerous Dog Breeds:</strong> Wooffer does not accept breeds
        banned under the Dangerous Dogs Act 1991 or animals listed under the
        Dangerous Wild Animals Act 1976.
      </p>

      <p>
        <strong>Hold Harmless Agreement:</strong> Wooffer is not liable for
        issues during or after the ride caused by pets or riders.
      </p>

      <p>
        <strong>Pet Attacks:</strong> Pet owners are liable for any injuries to
        drivers. Vehicles may be equipped with cameras for documentation.
      </p>

        <h5><strong>SMS/Mobile Messaging Policy</strong></h5>
        <ul>
            <li>
                <strong>Consent:</strong> When you sign up, you provide your phone number to receive <strong>transactional SMS only</strong> (such as OTPs and login verification). We do not send marketing or promotional messages.
            </li>
            <li>
                <strong>No Third-Party Sharing:</strong> Mobile information will not be shared with third parties/affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
            </li>
            <li>
                <strong>Opt-Out:</strong> You can opt-out of messages at any time by replying <strong>STOP</strong>.
            </li>
        </ul>

    </div>

    <!-- Refund Policy (hidden) -->
    <div _ngcontent-aun-c114 style="display: none">
      <div class="text-center my-3">
        <!-- <img src="assets/img/legal-refund.png" class="img-responsive" /> -->
      </div>
      <p>
        To refund a rider, send an email to info@wooffertechnologies.com with
        the reason. Wooffer must approve all refunds. Earnings may be held
        during the investigation.
      </p>
    </div>

    <!-- Cancellation Policy (hidden) -->
    <div _ngcontent-aun-c114 style="display: none">
      <div class="text-center my-3">
        <!-- <img src="assets/img/legal-cancellation.png" class="img-responsive" /> -->
      </div>
      <p>
        If you receive a ride request but are unavailable, you may cancel the
        ride by tapping the ‘Cancel’ button.
      </p>
    </div>
  </div>
</div>
